module.exports = __webpack_public_path__ + "img/black-lock.0897950.svg";